var _excluded = ["onCloseClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { Component, createRef, Fragment } from 'react';
import PropTypes from 'prop-types';
import { CloseIcon } from '@domain-group/fe-co-icon';
import { withSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { LinkButton } from '@domain-group/fe-co-allhomes-design-system';
import AllhomesMap from '@domain-group/fe-co-allhomes-map';
import OverlayPopup from './overlay-popup';
import LandDetails from './land-details';
import { changeLayerWhenPossible } from './utils';
import * as styles from './modal-map.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var STREET_VIEW_API_URL = 'https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=';
var DIRECTIONS_API_URL = 'https://www.google.com/maps/dir/?api=1&destination=';
var overrideOptions = {
  mapTypeControl: false,
  zoomControl: false,
  streetViewControl: false,
  fullscreenControl: false,
  gestureHandling: 'greedy' // use both one and two finger swipes for panning
};
class ModalMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLandDetails: false
    };
    this.landDetailsControl = /*#__PURE__*/createRef();
  }
  render() {
    var _this$props = this.props,
      onCloseClick = _this$props.onCloseClick,
      otherProps = _objectWithoutProperties(_this$props, _excluded);
    var center = "".concat(this.props.coords.lat, ",").concat(this.props.coords.lng);
    return ___EmotionJSX("div", {
      css: styles.mapModal
    }, ___EmotionJSX("div", {
      css: styles.mapTop
    }, ___EmotionJSX("button", {
      type: "button",
      css: styles.closeButton,
      onClick: onCloseClick,
      "aria-label": "Close"
    }, ___EmotionJSX(CloseIcon, {
      size: "regular"
    }))), this.state.isLandDetails ? ___EmotionJSX(LandDetails, _extends({
      onOverlaySelect: layerKey => {
        if (layerKey) {
          this.props.onOverlaySelect(layerKey);
        }
      },
      displayBottom: false,
      ref: this.landDetailsControl
    }, this.props.landDetailsConfig)) : ___EmotionJSX(Fragment, null, ___EmotionJSX(AllhomesMap, _extends({
      css: styles.canvas(this.props.overlayMapEnabled),
      useBrandedStyles: false,
      overrideOptions: overrideOptions
    }, otherProps)), ___EmotionJSX("div", {
      css: styles.mapBottom(this.props.overlayMapEnabled)
    }, ___EmotionJSX(LinkButton, {
      css: styles.mapBottomAllhomesButton,
      appearance: "outline",
      href: "".concat(STREET_VIEW_API_URL).concat(center)
    }, "Street View"), ___EmotionJSX(LinkButton, {
      css: styles.mapBottomAllhomesButton,
      appearance: "outline",
      href: "".concat(DIRECTIONS_API_URL).concat(center),
      onClick: () => this.props.sendEvent('directions-click')
    }, "Directions"))), this.props.overlayMapEnabled && ___EmotionJSX(OverlayPopup, {
      onOverlayToggle: isOn => {
        this.setState({
          isLandDetails: isOn
        });
      },
      onOverlaySelect: (layerKey, isSchool) => {
        changeLayerWhenPossible({
          layerKey,
          isSchool,
          landDetailsControl: this.landDetailsControl
        });
      }
    }));
  }
}

// eslint-disable-next-line react/forbid-foreign-prop-types
var _LandDetails$propType = LandDetails.propTypes,
  onOverlaySelect = _LandDetails$propType.onOverlaySelect,
  landDetailsConfigType = _objectWithoutProperties(_LandDetails$propType, ["onOverlaySelect"]);
ModalMap.propTypes = _objectSpread(_objectSpread({}, AllhomesMap.propTypes), {}, {
  onCloseClick: PropTypes.func.isRequired,
  landDetailsConfig: PropTypes.shape(landDetailsConfigType),
  onOverlaySelect: PropTypes.func,
  overlayMapEnabled: PropTypes.bool.isRequired,
  sendEvent: PropTypes.func
});
ModalMap.defaultProps = {
  onOverlaySelect: () => {},
  landDetailsConfig: null,
  sendEvent: () => {}
};
export default withSendEvent(ModalMap);